import React from 'react'
import { useAuthState } from '../../auth/authTools'
import { LoginTemplate } from '../templates/LoginTemplate'
import { LoginForm } from '../molecules/LoginForm'

export const LoginPage: React.FC = () => {
  const { error } = useAuthState()

  return (
    <LoginTemplate error={error}>
      <LoginForm />
    </LoginTemplate>
  )
} 